angular.module('zc.masterApi')

.factory "MasterProjectParticularEvent", ($resource, $q, BaseProjectCrudService) ->
  class MasterProjectParticularEvent extends BaseProjectCrudService

  new MasterProjectParticularEvent(
    $resource
    $q
    "/api/master/projects/:projectId/particular_events/:id"
    "particular_event"
    "particular_events"
  )




// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/api/particular_event.service.js.coffee